import { ICommandBarItemProps } from '@fluentui/react';

export const commandBarRefreshItem: ICommandBarItemProps = {
  key: 'refresh',
  text: 'Refresh',
  iconProps: { iconName: 'Refresh' },
  onClick: () => {
    window.parent.location = window.parent.location.href;
  },
  buttonStyles: {
    root: {
      background: 'none',
    },
  },
};
